import React from 'react'
import PropTypes from 'prop-types'
import reportError from '../common/report-error'

// Thanks Dan Abramov :-)
export class ErrorBoundary extends React.Component {
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error }
    }

    constructor(props) {
        super(props)
        this.state = { hasError: false }
    }

    componentDidCatch(error, info) {
        console.error('Caught unhandled exception!', error, info)
        reportError(error)
    }

    render() {
        const { error, hasError } = this.state
        if (!hasError) {
            return this.props.children
        }
        const { Fallback, doPrintCause = false } = this.props
        if (Fallback !== undefined) {
            return <Fallback {...{ error }} />
        }
        let cause = null
        if (doPrintCause) {
            let errorString = ''
            if (error !== undefined) {
                if (error.toString !== undefined && typeof error.toString === 'function') {
                    errorString = `${error.toString()} - Stack: ${error.stack}`
                } else {
                    errorString = JSON.stringify(error)
                }
            }
            cause = <pre>{errorString}</pre>
        }
        return (
            <div>
                <p>Something went wrong.</p>
                {cause}
            </div>
        )
    }
}
ErrorBoundary.propTypes = {
    doPrintCause: PropTypes.bool,
    Fallback: PropTypes.elementType
}
